module.exports = __webpack_public_path__ + "static/media/iconxiala.0253c293.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/iconxiala.png
// module id = 2171
// module chunks = 0